import axios from "axios";

const createSourceDefinition = () =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/source_definitions/create`);

const fetchSourceDefinitions = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/source_definitions/list`,
    payload,
    {
      headers: { common: undefined },
    }
  );

const fetchSourceDefinitionSpecifications = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/source_definition_specifications/get`,
    payload,
    { headers: { common: undefined } }
  );

const fetchSourceDefinitionDetails = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/source_definitions/get`,
    payload,
    { headers: { common: undefined } }
  );

const fetchDestinationDefinitionDetails = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/destination_definitions/get`,
    payload,
    { headers: { common: undefined } }
  );

const fetchDestinationDefinitions = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/destination_definitions/list`,
    payload,
    {
      headers: { common: undefined },
    }
  );

const fetchDestinationDefinitionSpecifications = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/destination_definition_specifications/get`,
    payload,
    { headers: { common: undefined } }
  );

const createSource = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/sources/create`, payload, {
    headers: { common: undefined },
  });

const createDestination = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/destinations/create`, payload, {
    headers: { common: undefined },
  });

const fetchSources = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/sources/list`, payload, {
    headers: { common: undefined },
  });

const fetchDestinations = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/destinations/list`, payload, {
    headers: { common: undefined },
  });

const fetchConnections = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/web_backend/connections/list`,
    payload,
    { headers: { common: undefined } }
  );

const fetchConnectionDetails = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/web_backend/connections/get`,
    payload,
    { headers: { common: undefined } }
  );

const fetchCatalog = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/sources/discover_schema`,
    payload,
    {
      headers: { common: undefined },
    }
  );

const fetchJobs = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/jobs/list`, payload, {
    headers: { common: undefined },
  });

const createConnection = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/web_backend/connections/create`,
    payload,
    { headers: { common: undefined } }
  );

const syncConnection = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/connections/sync`, payload, {
    headers: { common: undefined },
  });

const updateConnection = payload =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/web_backend/connections/update`,
    payload,
    {
      headers: { common: undefined },
    }
  );

const deleteConnection = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/connections/delete`, payload, {
    headers: { common: undefined },
  });

const fetchWorkspaces = () =>
  axios.post(
    `${process.env.AIRBYTE_URL}/api/v1/workspaces/list`,
    {},
    {
      headers: { common: undefined },
    }
  );

const updateWorkspace = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/workspaces/update`, payload, {
    headers: { common: undefined },
  });

const cancelJob = payload =>
  axios.post(`${process.env.AIRBYTE_URL}/api/v1/jobs/cancel`, payload, {
    headers: { common: undefined },
  });

const AirbyteApi = {
  createSourceDefinition,
  createSource,
  fetchSources,
  fetchConnections,
  fetchCatalog,
  createDestination,
  fetchDestinations,
  createConnection,
  syncConnection,
  fetchSourceDefinitions,
  fetchSourceDefinitionDetails,
  fetchDestinationDefinitionDetails,
  fetchSourceDefinitionSpecifications,
  fetchDestinationDefinitionSpecifications,
  fetchDestinationDefinitions,
  fetchConnectionDetails,
  fetchJobs,
  updateConnection,
  deleteConnection,
  fetchWorkspaces,
  updateWorkspace,
  cancelJob,
};

export default AirbyteApi;
